import { VERIFY_CURRENT_SESSION_API } from "../../constants/api";
import axios from "../fetch/fetch";

export const verifyCurrentSessionAPI = async (): Promise<{ adminEventsUrl?: string }> => {
  const res = await axios.post(`${VERIFY_CURRENT_SESSION_API}`);
  return res.data;
};
